import React, { useEffect, useState } from "react";
import { Button, Col, Stack } from "react-bootstrap";
import { ConnectAccountsEvents } from "../../../utils/constants/events-types";
import EventDispatcher from "../../../utils/event-dispatcher";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import usePaymentRedirect from "../../../hooks/usePaymentRedirect";
import { ROUTES } from "../../../utils/constants";
import "./ConnectAccountsStatus.scss";

export enum ConnectAccountsStatusType {
  LOADING = "loading",
  DONE = "done",
}

interface ConnectAccountsStatusProps {
  type: ConnectAccountsStatusType;
  title: string;
  message?: string;
  eventType?: ConnectAccountsEvents;
  navigateUrl?: string;
}

function ConnectAccountsStatus({
  type,
  title,
  message,
  eventType,
  navigateUrl = ROUTES.ROOT.DASHBOARD,
}: ConnectAccountsStatusProps) {
  const { handlePaymentRedirect } = usePaymentRedirect();
  const [showContinueBtn, setShowContinueBtn] = useState<boolean>(false);

  const handleContinue = () => {
    if (eventType) {
      EventDispatcher.dispatch(eventType, { message: message || title });
      handlePaymentRedirect(navigateUrl);
    }
    return;
  };

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (!showContinueBtn) {
      timeoutId = setTimeout(() => setShowContinueBtn(true), 4000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [showContinueBtn]);

  return (
    <Col className="d-flex flex-column text-center justify-content-center px-3 align-items-center Grotesk ConnectAccountsStatus">
      <Stack
        gap={type === ConnectAccountsStatusType.LOADING ? 4 : 5}
        className={`
          text-center
          ${
            type === ConnectAccountsStatusType.LOADING || !showContinueBtn
              ? "justify-content-center"
              : "justify-content-end"
          }
        `}
      >
        {type === ConnectAccountsStatusType.LOADING && <LoadingSpinner />}
        <div>
          <p className="text-center ConnectAccountsStatusTitle">{title}</p>
          {message && (
            <p className="mt-3 text-center ConnectAccountsStatusMessage">
              {message}
            </p>
          )}
        </div>
        {type === ConnectAccountsStatusType.DONE && (
          <p className="RedirectMessage">You will be redirected shortly</p>
        )}
      </Stack>

      {type === ConnectAccountsStatusType.DONE && showContinueBtn && (
        <div>
          <Button variant="link" onClick={handleContinue}>
            Continue
          </Button>
        </div>
      )}
    </Col>
  );
}

export default ConnectAccountsStatus;
